import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FormNavigation = ({ 
  currentStep, 
  totalSteps, 
  onPrevious, 
  onNext, 
  onSubmit, 
  isSubmitting,
  canProceed 
}) => {
  const isFirstStep = currentStep === 1;
  const isLastStep = currentStep === totalSteps;
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="bg-white/95 backdrop-blur-sm border-t border-border px-6 py-4 sticky bottom-0 z-50 shadow-lg">
      <div className="max-w-4xl mx-auto flex items-center justify-between">
        {/* Previous Button */}
        <div className="flex-1">
          {!isFirstStep && (
            <Button
              variant="outline"
              onClick={onPrevious}
              iconName="ChevronLeft"
              iconPosition="left"
              disabled={isSubmitting}
            >
              Previous
            </Button>
          )}
        </div>

        {/* Step Indicator */}
        <div className="flex-1 text-center">
          <span className="text-sm text-text-secondary">
            Step {currentStep} of {totalSteps}
          </span>
        </div>

        {/* Next/Submit Button */}
        <div className="flex-1 flex justify-end items-center space-x-3">
          {!canProceed && !isLastStep && (
            <div className="flex items-center space-x-2 text-sm text-amber-600 bg-amber-50 px-3 py-2 rounded-md border border-amber-200">
              <Icon name="AlertCircle" size={16} className="flex-shrink-0" />
              <span className="font-medium">Please fill all required fields</span>
            </div>
          )}
          
          {isLastStep ? (
            <div className="relative">
              <Button
                variant="default"
                onClick={onSubmit}
                loading={isSubmitting}
                disabled={!canProceed || isSubmitting}
                iconName="Send"
                iconPosition="right"
                onMouseEnter={() => !canProceed && setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                {isSubmitting ? 'Submitting...' : 'Submit Registration'}
              </Button>
              {!canProceed && showTooltip && (
                <div className="absolute bottom-full right-0 mb-2 px-3 py-2 bg-gray-900 text-white text-xs rounded shadow-lg whitespace-nowrap">
                  Please complete all required agreements
                </div>
              )}
            </div>
          ) : (
            <div className="relative">
              <Button
                variant="default"
                onClick={onNext}
                disabled={!canProceed}
                iconName="ChevronRight"
                iconPosition="right"
                onMouseEnter={() => !canProceed && setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                Next
              </Button>
              {!canProceed && showTooltip && (
                <div className="absolute bottom-full right-0 mb-2 px-3 py-2 bg-gray-900 text-white text-xs rounded shadow-lg whitespace-nowrap">
                  Please fill all required fields to continue
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormNavigation;